import React, { useEffect, useState } from "react";
import { apiGet } from "../../Utils/apiFetch";
import apiPath from "../../Utils/apiPath";
import { toFixedWithoutRounding } from "../../Utils/constants";
import { RxCross2 } from "react-icons/rx";
import { isMobile } from "react-device-detect";

const BookPosition = ({ object, setFancyModal }) => {
  let obj = {
    4: "Cricket",
    2: "Tennis",
    1: "Soccer",
    3: "Casino",
  };
  const [data, setData] = useState([]);
  const getFancyBetPosition = async () => {
    const { status, data: response_users } = await apiGet(
      apiPath.bookPosition +
        `?eventId=${object?.eventId}&type=${
          obj[object?.categoryType]
        }&selectionId=${object?.selectionId}&marketId=${object?.marketId}`
    );

    if (status === 200) {
      if (response_users.success) {
        setData(response_users.results);
      }
    }
  };
  useEffect(() => {
    if (object?.prevPosition) {
      getFancyBetPosition();
    }
  }, [object]);

  return (
    <div data-v-6fadc082>
      <div
        data-v-6fadc082
        data-testid="btn-hidden-book-modal"
        className={` ${
          isMobile ? "s-w-full" : "s-w-desktop"
        } s-absolute s-top-0 s-h-full s-z-70 s-bg-black s-opacity-30`}
        style={{}}
      />
      <div
        data-v-6fadc082
        className={`${
          isMobile ? "s-w-full" : "s-w-desktop"
        } s-book s-fixed s-z-70 s-bottom-0 s-text-global-font-default-light dark:s-text-global-font-default-dark s-pt-64px`}
        data-testid="container-book-modal"
        style={{}}
      >
        <div
          data-v-6fadc082
          className="s-bg-pop-title-bg s-flex s-flex-col s-px-1 s-h-full s-overscroll-y-none s-rounded-t-5px"
        >
          <div
            data-v-6fadc082
            className="s-pt-13px s-pb-12px s-flex s-justify-center"
          >
            <p
              data-v-6fadc082
              className="s-text-17px s-font-bold s-text-pop-title-text"
            >
              Book Position
            </p>
            <RxCross2
              onClick={() =>
                setFancyModal({
                  status: false,
                  object: {},
                })
              }
              size={16}
              style={{ position: "absolute", right: "10px" }}
              className="s-absolute s-right-4 s-icon-close s-text-14px"
            />
          </div>
          <div
            data-v-6fadc082
            className="s-relative s-py-12px s-px-7px s-rounded-t-md s-text-center s-bg-white dark:s-bg-black-800 s-border-b s-border-black-300 dark:s-border-black-900"
          >
            <div data-v-6fadc082 className="s-text-start">
              <span
                data-v-6fadc082
                data-testid="bookData-eventName-home"
                className="s-text-17px s-font-bold s-leading-120"
              >
                {object?.match}
              </span>

              <span
                data-v-6fadc082
                className="s-icon-triangle-black-600 dark:is-dark s-inline-block s-align-baseline"
              />
              <span
                data-v-6fadc082
                data-testid="bookData-marketName"
                className="s-text-17px s-leading-120"
              >
                {object?.fancyName}
              </span>
            </div>
          </div>
          <section
            data-v-11b7e398
            className="s-py-9px s-pl-10px s-text-15px s-bg-white dark:s-bg-black-800"
          >
            Runs
          </section>
          <section
            data-v-11b7e398
            className="s-content s-bg-white dark:s-bg-black-800 s-overflow-y-scroll s-px-3px"
          >
            {data?.bets?.length > 0 &&
              data?.bets?.map((res) => {
                return (
                  <div
                    data-v-11b7e398
                    className={`s-flex s-justify-center s-items-center s-text-global-font-default-light ${
                      res?.position >= 0 ? "s-bg-back-100" : "s-bg-lay-100"
                    } `}
                    data-testid={158}
                  >
                    <div
                      data-v-11b7e398
                      className="s-py-7px s-px-14px s-w-1/3 s-text-15px s-font-bold s-border-b s-border-white s-border-r dark:s-border-black-900"
                    >
                      {res.betRun}
                    </div>
                    <div
                      data-v-11b7e398
                      style={{ color: res?.position >= 0 ? "" : "red" }}
                      className="s-py-7px s-px-14px s-w-2/3 s-text-15px s-font-bold s-border-b s-border-white dark:s-border-black-900"
                    >
                      {res?.position >= 0
                        ? `${toFixedWithoutRounding(res?.position)}`
                        : `(${Math.abs(
                            toFixedWithoutRounding(res?.position)
                          )})`}
                    </div>
                  </div>
                );
              })}
          </section>
        </div>
      </div>
    </div>
  );
};

export default BookPosition;
